import { render, staticRenderFns } from "./type_2.vue?vue&type=template&id=bd722b66&scoped=true"
import script from "./type_2.vue?vue&type=script&lang=js"
export * from "./type_2.vue?vue&type=script&lang=js"
import style0 from "./type_2.vue?vue&type=style&index=0&id=bd722b66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd722b66",
  null
  
)

export default component.exports